import React from 'react';

const HorizontalTabs = ({ tabs, activeTab, onChange }) => {
    // Prevent default event behavior to avoid potential page refreshes
    const handleTabClick = (e, index) => {
        e.preventDefault();
        e.stopPropagation(); // Also stop event propagation
        onChange(index);
    };

    return (
        <div className="bg-black/30 rounded-lg overflow-hidden shadow-sm hidden md:block">
            <div className="w-full flex items-center justify-center text-[20px] tracking-wider border-b border-white/20">
                {tabs.map((tab, index) => (
                    <button
                        key={index}
                        type="button"
                        className={`flex-1 text-center py-4 px-4 transition-all duration-500 relative ${activeTab === index
                            ? 'text-white font-medium'
                            : 'text-white/60 hover:text-white/80'
                            }`}
                        onClick={(e) => handleTabClick(e, index)}
                    >
                        {tab.label}
                        {activeTab === index && (
                            <span className="absolute bottom-0 left-0 w-full h-[2px] bg-gradient-to-r from-[#9b64eb] to-[#dd9a4d]"></span>
                        )}
                    </button>
                ))}
            </div>
        </div>
    );
};

export default HorizontalTabs;
